export class PasswordGenerator {
  public static generatePassword() {
    let result = '';
    const charTypes = [
      'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
      'abcdefghijklmnopqrstuvwxyz',
      '0123456789',
      '!"#$&\'()*,-./:;<=>?@[]^_`{|}~',
    ];
    
    let remainder = 16 - 2 * charTypes.length; // 16 is target length, we want at least two of every type
    for (let i = 0; i < charTypes.length; i++) {
      let numberOfCharacters = 0;
      if (remainder > 0) {
        if (i + 1 >= charTypes.length) {
          numberOfCharacters = remainder;
        } else {
          const rand = Math.random() * remainder;
          const ceil = Math.ceil(rand);
          numberOfCharacters = Math.ceil(Math.random() * remainder);
        }
      }
      
      remainder -= numberOfCharacters;
      result += this.getRandomChars(charTypes[i], numberOfCharacters + 2); // we want at least two of every type
    }

    // mix characterpositions
    let password = '';
    while(result.length > 0) {
      const charIndex = Math.floor(Math.random() * result.length);
      password += result.charAt(charIndex);
      const sub1 = result.slice(0, charIndex);
      const sub2 = result.slice(charIndex + 1, result.length);
      result = sub1 + sub2;
    }
    return password;
  }

  public static getRandomChars(source: string, numCharacters: number) {
    let result = '';
    for (let i = 0; i < numCharacters; i++) {
      result += this.getRandomChar(source);
    }
    return result;
  }

  public static getRandomChar(source: string) {
    return source.charAt(Math.floor(Math.random() * source.length));
  }
}